import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import type { VenueMigrationResponse } from '../models/venue.model';
@Injectable({
  providedIn: 'root',
})
export class ContentDistributionVenuesApiService {
  private apiRoot = '/api/venues';

  constructor(private http: HttpClient) {}

  public getbycode(
    code,
    page,
    client_id?: number,
    operator?: boolean,
    order?: string,
    direction?: 'desc' | 'asc'
  ): Observable<any> {
    const queryParams: Record<string, any> = { page, client_id, operator, order, direction };
    let params = new HttpParams().set('related', 'regions,clients,maps,views');
    Object.entries(queryParams).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        params = params.set(key, String(value));
      }
    });

    return this.http.get<any>(environment.contentdistribution.private.url + `${this.apiRoot}/code/${code}`, {
      params,
    });
  }

  public getbyCDKey(
    cdKey,
    page,
    client_id?: number,
    operator?: boolean,
    order?: string,
    direction?: 'desc' | 'asc'
  ): Observable<any> {
    const queryParams: Record<string, any> = { page, client_id, operator, order, direction };
    let params = new HttpParams().set('related', 'regions,clients,maps,views');
    Object.entries(queryParams).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        params = params.set(key, String(value));
      }
    });
    return this.http.get<any>(environment.contentdistribution.private.url + `${this.apiRoot}/cdkey/${cdKey}`, {
      params,
    });
  }

  public getByKeyList(
    body: { keys: string[] },
    fields: string,
    page: number,
    order?: string,
    direction?: 'desc' | 'asc'
  ) {
    let params = new HttpParams().set('fields', fields).set('page', page).set('related', 'regions,clients,maps,views');
    params = order ? params.set('order', order) : params;
    params = direction ? params.set('direction', direction) : params;
    return this.http.post<any>(environment.contentdistribution.private.url + `${this.apiRoot}/key`, body, { params });
  }

  public postVenueRegion(code: string, regions: number[]) {
    const body = {
      regions: regions,
    };
    return this.http.patch<any>(environment.contentdistribution.private.url + `${this.apiRoot}/${code}/regions`, body);
  }
  public patchVenueClients(id: number, clientsIds: number[], overwrite?: boolean) {
    const body = {
      clientIds: clientsIds,
    };
    let ov = 'true';
    if (!overwrite) {
      ov = 'false';
    }
    return this.http.patch<any>(
      environment.contentdistribution.private.url + `${this.apiRoot}/${id}/clients?overwrite=${ov}`,
      body
    );
  }
  public getVenuesbyCodeList(codes: string[]) {
    const body = {
      codes: codes,
    };
    return this.http.post<any>(
      environment.contentdistribution.private.url + `${this.apiRoot}/code?fields=key,code,config_key`,
      body
    );
  }
  public patchVenueKey(id, data: { key: string }) {
    const body = {
      key: data.key,
    };
    return this.http.patch<any>(environment.contentdistribution.private.url + `${this.apiRoot}/${id}`, body);
  }

  public checkIfVenueCodeExist(code: string): Observable<any> {
    return this.http.get(environment.contentdistribution.private.url + `/api/venues/code/search`, {
      params: new HttpParams().set('code', code),
    });
  }

  public toggleVenueMigration(code: string): Observable<VenueMigrationResponse> {
    return this.http.patch<VenueMigrationResponse>(
      environment.contentdistribution.private.url + `${this.apiRoot}/${code}/migration`,
      null
    );
  }
}
